<div #paramform class="main-container">
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="onRefresh()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title">OTA Master</span>
    </div>
    <div class="button-group">
      @if (!isAddOtaCommand && createOtaMaster) {
        <button class="primary-button" (click)="addOtaCommand()">
          Add OTA Command <mat-icon class="btn-icon">open_in_new</mat-icon>
        </button>
      }
    </div>
  </div>

  @if (!isAddOtaCommand) {
    <div class="component-container">
      <div class="component-header" [formGroup]="searchForm">
        <h6 class="component-title">OTA Command List</h6>
        <div class="component-actions">
          <app-common-search
            formControlName="searchInput"
            (searchSubmit)="onSearch($event)"
            (placeholder)="('Search by OTA Name or Command')"
            [initialSearchValue]="searchForm?.get('searchInput')?.value"
          ></app-common-search>
        </div>
      </div>
      <div class="component-separator"></div>
      <div class="component-body">
        <table>
          <tr>
            <th>OTA Name</th>
            <th>OTA Command</th>
            <th>Example</th>
            <th>Type</th>
            <th>Action</th>
          </tr>
          <tbody>
            @for (item of otaItems; track item) {
              <tr>
                <td>
                  {{ item.name }}
                </td>
                <td>
                  {{ item.otaCommand }}
                </td>
                <td>
                  {{ item.otaCommandExample }}
                </td>
                <td>
                  {{ item.type }}
                </td>
                <td>
                  <div class="action-buttons">
                    <button
                      class="primary-button view-button"
                      (click)="updateData(item)"
                    >
                      <mat-icon class="btn-icon">visibility</mat-icon>
                    </button>
                    @if (deleteOtaMaster) {
                      <button
                        class="primary-button delete-button"
                        (click)="delete(item.id)"
                      >
                        <mat-icon class="btn-icon">delete</mat-icon>
                      </button>
                    }
                  </div>
                </td>
              </tr>
            }
          </tbody>
          @if (otaItems.length === 0) {
            <tbody>
              <tr>
                <td colspan="12">
                  <img
                    loading="lazy"
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <div class="component-separator"></div>
      <div class="component-footer">
        @if (otaItems.length > 0) {
          <app-common-component-pagination
            [totalItems]="totalItems"
            [pageSize]="pageSize"
            [currentPage]="currentPage"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>
  }

  @if (isAddOtaCommand) {
    <div class="component-container">
      <!-- Component Header Section -->
      <div class="component-header">
        <h6 class="component-title">
          {{ UpdateOtaItem ? 'Update' : 'Add' }} OTA Command
        </h6>
      </div>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>
      <!-- Component Body Section -->
      <div class="component-body">
        <form [formGroup]="otaMaster" novalidate>
          <div class="form-section">
            <div class="form-group">
              <label for="name" class="form-label">OTA Name</label>
              <mat-form-field appearance="outline">
                <mat-label>OTA Name</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="name"
                  placeholder="Please Enter OTA Name"
                  required
                />
                @if (
                  otaMaster.controls['name'].touched &&
                  otaMaster.controls['name'].errors?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      otaMaster.controls['name'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <label
                for=""
                class="form-label"
                matTooltip="*SET,EXAMPLE,VAL# || *SET,EXAMPLE,1# || *CLR,EXAMPLE# || *GET,EXAMPLE#"
                >OTA Command</label
              >
              <mat-form-field appearance="outline">
                <mat-label>OTA Command</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="otaCommand"
                  placeholder="Please Enter OTA Command"
                  required
                />
                @if (
                  otaMaster.controls['otaCommand'].touched &&
                  otaMaster.controls['otaCommand'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      otaMaster.controls['otaCommand'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <label for="" class="form-label">OTA Type</label>
              <mat-form-field appearance="outline">
                <mat-label>OTA Type</mat-label>
                <mat-select formControlName="otaCommandType">
                  @for (value of otaTypeList; track value) {
                    <mat-option [value]="value">
                      {{ value }}
                    </mat-option>
                  }
                </mat-select>
                @if (
                  otaMaster.controls['otaCommandType'].touched &&
                  otaMaster.controls['otaCommandType'].invalid
                ) {
                  <mat-error> This field is mandatory. </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <label for="" class="form-label">Example</label>
              <mat-form-field appearance="outline">
                <mat-label>Example</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="otaCommandExample"
                  placeholder="Please Enter Example"
                  required
                />
                @if (
                  otaMaster.controls['otaCommandExample'].touched &&
                  otaMaster.controls['otaCommandExample'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      otaMaster.controls['otaCommandExample'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="form-group">
              <label for="" class="form-label">Input Field Required</label>
              <mat-form-field appearance="outline">
                <mat-label>Input Field Required</mat-label>
                <mat-select formControlName="isInputFieldRequired">
                  @for (value of InputFields; track value) {
                    <mat-option [value]="value">
                      {{ value }}
                    </mat-option>
                  }
                </mat-select>
                @if (
                  otaMaster.controls['isInputFieldRequired'].touched &&
                  otaMaster.controls['isInputFieldRequired'].invalid
                ) {
                  <mat-error> This field is mandatory. </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </form>
      </div>
      <div class="component-separator"></div>
      <div class="component-footer">
        <div class="button-group">
          @if (AddOtaItemBtn && createOtaMaster) {
            <button
              class="submit-button"
              (click)="submitOTACommand()"
              [disabled]="this.otaMaster.invalid"
            >
              Submit<mat-icon class="btn-icon">check_circle</mat-icon>
            </button>
          }
          @if (UpdateOtaItem && updateOtaMaster) {
            <button class="edit-button" (click)="submitOTACommand()">
              Update <mat-icon class="btn-icon">edit</mat-icon>
            </button>
          }
        </div>
      </div>
    </div>
  }
</div>
